import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, UrlTree, Router } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { addItemToReturnOrderAction } from "../../store/actions/order.actions";
import { clientConfig } from "../constant/app.constant";
import { CopyHelpers } from "../helpers/copy.helpers";
import { AppFlowService } from "./../services/app-flow/app-flow.service";

@Injectable({
  providedIn: "root",
})
export class TechSupportRouteGuard  {
  returnOrder: any;

  constructor(private router: Router, private appFlowService: AppFlowService, private store: Store<AppState>) {}

  canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentPath = next.routeConfig.path;
    console.log("current :>> ", currentPath);

    const appFlow = this.appFlowService.getActiveAppFlow();
    const parent = next.parent.routeConfig.path;
    const current = appFlow.sequence.find((s) => s.path === next.routeConfig.path);

    let orderData: any;
    this.store
      .pipe(select("orderData"))
      .pipe(take(1))
      .subscribe((o) => {
        orderData = o;
      });

    this.store.pipe(select("returnOrder")).subscribe((items) => {
      this.returnOrder = CopyHelpers.deepCopy(items);
    });

    this.fillReturnOrderItems();

    if (
      this.returnOrder &&
      clientConfig.TECH_SUPPORT_CONFIG &&
      clientConfig.TECH_SUPPORT_CONFIG.techSupportAssessment &&
      clientConfig.TECH_SUPPORT_CONFIG.techSupportAssessment.length !== 0
    ) {
      const orderLineAssessmentIds = this.returnOrder.items
        .filter((o) => o.returnable === true && o.assessmentId)
        .map((orderLine) => orderLine.assessmentId);
      const techSupportAssessment = clientConfig.TECH_SUPPORT_CONFIG.techSupportAssessment.filter((assessment) =>
        orderLineAssessmentIds.includes(assessment.assessmentId)
      );

      if (techSupportAssessment && techSupportAssessment.length !== 0) {
        return true;
      }
    }
    return this.router.parseUrl(`${parent}/${current.next}`);
  }

  fillReturnOrderItems() {
    if (clientConfig.APPFLOW === "formPostPrePopulatedOrderTechSupportFlow") {
      this.returnOrder.orderLines.forEach((orderLine) => {
        if (
          (this.returnOrder.items.findIndex((x) => x.itemNumber === orderLine.itemNumber) === -1 ||
            this.returnOrder.items.findIndex((x) => x.itemName === orderLine.itemName) === -1) &&
          orderLine.returnable
        ) {
          const newItem = CopyHelpers.deepCopy(orderLine);
          newItem.returnQuantity = newItem.quantityToReturn;
          this.store.dispatch(addItemToReturnOrderAction({ payload: { item: newItem } }));
        }
      });
    }
  }
}
